import React, { FunctionComponent, Fragment, useState, useEffect } from 'react';
import {
	Checkbox,
	CheckboxGroup,
	FieldWrapper,
	Paragraph,
} from '@mlc/web-ui-toolkit';
import { FinancialPlanningSoftware } from '../../../../logic/domains/epi.domain';
import { toFpsIdentifier } from '../utils';

type Props = {
	isInvalid: boolean;
	fpsOptions: FinancialPlanningSoftware[];
	value?: string[];
	onCheckedHandler: (value: string[]) => void;
};

const ProductsForm: FunctionComponent<Props> = ({
	fpsOptions,
	value,
	isInvalid,
	onCheckedHandler,
}) => {
	const [checked, setChecked] = useState<string[]>([]);

	useEffect(() => {
		setChecked(value || []);
	}, [value]);

	const onChecked = (event: any, { value }: any) => {
		setChecked(value);
		onCheckedHandler(value);
	};

	const DEPRECATED_OPTION = 'OTHER';
	const deprecated = (o: FinancialPlanningSoftware) => {
		return o.value.toUpperCase() !== DEPRECATED_OPTION;
	};

	if (fpsOptions.length === 0) {
		throw new Error('FPS data is missing');
	}

	return (
		<Fragment>
			<FieldWrapper
				name="financial-planning-software"
				label={
					<Paragraph paddingBottom={6}>
						Register the financial planning software you want to connect with
						Client Data Exchange:
					</Paragraph>
				}
				error="No software selected"
				isInvalid={isInvalid}
				style={{ marginBottom: '0px' }}
			>
				<CheckboxGroup
					name="financialProducts"
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						flexDirection: 'column',
					}}
					value={checked}
					onChange={onChecked}
				>
					{fpsOptions.filter(deprecated).map(p => (
						<Checkbox
							key={'cb' + p.id}
							value={toFpsIdentifier(p)}
							label={p.value}
							data-analytics-capture-value
						/>
					))}
				</CheckboxGroup>
			</FieldWrapper>
			<div
				key="emptyFPSOptionsDiv"
				style={{ marginLeft: '20px', maxWidth: '40px', textAlign: 'right' }}
			/>
		</Fragment>
	);
};

export default ProductsForm;
